/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['del mediodía', 'de la madrugada', 'de la mañana', 'de la tarde', 'de la noche'],
    ,
  ],
  [
    ['m.', 'madrugada', 'mañana', 'tarde', 'noche'],
    ['mediodía', 'madrugada', 'mañana', 'tarde', 'noche'],
  ],
  ['12:00', ['00:00', '06:00'], ['06:00', '12:00'], ['12:00', '20:00'], ['20:00', '24:00']]
];
